{
  "seo": {
    "title": "Sign In",
    "description": "Sign in to CuriPop to save your progress, track your child's learning journey, and unlock personalized content."
  },
  "labels": {
    "logoAlt": "Curipop Logo",
    "developmentMode": "Development Mode",
    "tip": "Tip:"
  },
  "welcomeTag": "Welcome back!",
  "headline": "Let's Explore!",
  "subhead": "Sign in to continue where you left off",
  "whoSigningIn": "Who is signing in?",
  "actions": {
    "continueWithGoogle": "Continue with Google",
    "continueWithFacebook": "Continue with Facebook",
    "continueWithX": "Continue with X"
  },
  "errors": {
    "accessCodeNotFound": "Access code not found"
  },
  "mockAuth": "Mock auth is enabled for development",
  "kidSection": {
    "title": "Kid Quick Sign In",
    "subtitle": "Enter your family access code to continue.",
    "placeholder": "ABC1234",
    "checking": "Checking...",
    "continue": "Continue as Kid",
    "fullPage": "Open full kid login page"
  }
}
